import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { useState } from "react";

interface ChartFilterProps {
  onClose: () => void;
  onTimeRangeChange: (timeRange: string) => void;
}

const ChartFilter: React.FC<ChartFilterProps> = ({ onClose, onTimeRangeChange }) => {
  const [options, setOptions] = useState({
    thirtymin: false,
    onehour: false,
    twelvehours: false,
    twenty4hours: false,
  });

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setOptions({
      thirtymin: false,
      onehour: false,
      twelvehours: false,
      twenty4hours: false,
      [name]: true,
    });
    onTimeRangeChange(name);
  };

  return (
    <div
      style={{
        position: "absolute",
        right: "10px",
        top: "210px",
        transform: "translateY(-50%)",
        backgroundColor: "rgba(85, 84, 95, 1)",
        padding: "10px",
        borderRadius: "5px",
        width: "200px",
        height: "180px",
        zIndex: "999",
      }}
    >
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            color: "white",
            fontSize: "18px",
          }}
        >
          Time Range
        </div>
        <div style={{ width: "20%", display: "flex", justifyContent: "flex-end" }}>
          <FontAwesomeIcon
            onClick={onClose}
            onTouchStart={onClose}
            style={{
              cursor: "pointer",
              color: "red",
              border: "3px solid #dc143c",
              borderRadius: "50%",
              width: "15px",
              height: "15px",
            }}
            icon={faClose}
          />
        </div>
      </div>
      <div
        style={{
          height: "50%",
          display: "flex",
          flexDirection: "column",
          borderRadius: "2px",
          padding: "5px",
        }}
      >
        <FormGroup style={{ color: "white", fontSize: "9px" }}>
          <FormControlLabel
            control={
              <Checkbox
                name="thirtymin"
                checked={options.thirtymin}
                onChange={handleCheckboxChange}
                sx={{
                  color: "white",
                  "&.Mui-checked": { color: "white" },
                }}
              />
            }
            label="30 Minutes"
            sx={{ width: "100%" }}
          />
          <FormControlLabel
            control={
              <Checkbox
                name="onehour"
                checked={options.onehour}
                onChange={handleCheckboxChange}
                sx={{
                  color: "white",
                  "&.Mui-checked": { color: "white" },
                }}
              />
            }
            label="1 Hour"
            sx={{ width: "100%" }}
          />
          <FormControlLabel
            control={
              <Checkbox
                name="twelvehours"
                checked={options.twelvehours}
                onChange={handleCheckboxChange}
                sx={{
                  color: "white",
                  "&.Mui-checked": { color: "white" },
                }}
              />
            }
            label="12 Hours"
            sx={{ width: "100%" }}
          />
          <FormControlLabel
            control={
              <Checkbox
                name="twenty4hours"
                checked={options.twenty4hours}
                onChange={handleCheckboxChange}
                sx={{
                  color: "white",
                  "&.Mui-checked": { color: "white" },
                }}
              />
            }
            label="24 Hours"
            sx={{ width: "100%" }}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default ChartFilter;
